// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1cLMo","info":"Note_info__2uNar","note":"Note_note__3_NHJ","actions":"Note_actions__3TXDA"};